import React, { useCallback } from 'react';
import { Input } from 'antd';
import type { InputProps } from 'antd';
import { normalizePhone } from '../../utils/normalizeNumber';

/**
 * 電話番号入力用のカスタムInput
 *
 * @description
 * 全角数字・ハイフン・カッコなどを自動的に半角に変換します。
 * 電話番号、携帯電話番号、FAX番号の入力に使用できます。
 *
 * @example
 * // 電話番号
 * <Form.Item name="phone" rules={[phoneNumberRule()]}>
 *   <PhoneInput placeholder="03-1234-5678" />
 * </Form.Item>
 *
 * // 携帯電話
 * <Form.Item name="mobilePhone" rules={[phoneNumberRule()]}>
 *   <PhoneInput placeholder="090-1234-5678" />
 * </Form.Item>
 *
 * // FAX
 * <Form.Item name="fax" rules={[phoneNumberRule()]}>
 *   <PhoneInput placeholder="03-1234-5679" />
 * </Form.Item>
 */
export const PhoneInput: React.FC<InputProps> = ({ onChange, ...props }) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const originalValue = e.target.value;
      const normalizedValue = normalizePhone(originalValue);

      // 正規化した値で新しいイベントを作成
      const newEvent = {
        ...e,
        target: {
          ...e.target,
          value: normalizedValue,
        },
      } as React.ChangeEvent<HTMLInputElement>;

      onChange?.(newEvent);
    },
    [onChange]
  );

  return <Input {...props} onChange={handleChange} />;
};

export default PhoneInput;
